"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfDigestHighlightDto = instanceOfDigestHighlightDto;
exports.DigestHighlightDtoFromJSON = DigestHighlightDtoFromJSON;
exports.DigestHighlightDtoFromJSONTyped = DigestHighlightDtoFromJSONTyped;
exports.DigestHighlightDtoToJSON = DigestHighlightDtoToJSON;
exports.DigestHighlightDtoToJSONTyped = DigestHighlightDtoToJSONTyped;
/**
 * Check if a given object implements the DigestHighlightDto interface.
 */
function instanceOfDigestHighlightDto(value) {
    if (!('url' in value) || value['url'] === undefined)
        return false;
    if (!('streamingPlatform' in value) || value['streamingPlatform'] === undefined)
        return false;
    return true;
}
function DigestHighlightDtoFromJSON(json) {
    return DigestHighlightDtoFromJSONTyped(json, false);
}
function DigestHighlightDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'url': json['url'],
        'thumbnailUrl': json['thumbnailUrl'] == null ? undefined : json['thumbnailUrl'],
        'streamingPlatform': json['streamingPlatform'],
        'durationSeconds': json['durationSeconds'] == null ? undefined : json['durationSeconds'],
    };
}
function DigestHighlightDtoToJSON(json) {
    return DigestHighlightDtoToJSONTyped(json, false);
}
function DigestHighlightDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'url': value['url'],
        'thumbnailUrl': value['thumbnailUrl'],
        'streamingPlatform': value['streamingPlatform'],
        'durationSeconds': value['durationSeconds'],
    };
}
